"use strict";
require('../../layouts/web');

var IpixBlogs = function() {

    IpixUtil.onDOMContentLoaded(function() {
        IpixBlogs.init();
    });

    var loadMoreBtnClick = function() {
        $(".loadmore").click(function() {
            IpixBlogs.loadMoreBlogs(true);
        });
    }
    // var loadBlogsOnScroll = function() {
    //     $(window).scroll(function() {
    //         if($(window).scrollTop() + $(window).height() == $(document).height()) {
    //             IpixBlogs.loadMoreBlogs(true);
    //         }
    //     });
    // }

    var allClick = function() {
        $(".all_category").click(function() {
            var $categoryId = null;
            $('input[name="offset"]').val(0);
            $('input[name="page"]').val(1);
            $('input[name="categoryId"]').val($categoryId);
            IpixBlogs.loadMoreBlogs(false);
        });
    }

    var categoryClick = function() {
        $(".blog_category").click(function() {
            var $categoryId = $(this).data("category-id");
            $('input[name="offset"]').val(0);
            $('input[name="page"]').val(1);
            $('input[name="categoryId"]').val($categoryId);
            IpixBlogs.loadMoreBlogs(false);
        });
    }

    var searchText = function() {
        $("#blogSearchText").on("input", function() {
            var blogSearchText = $(this).val();
            $('input[name="offset"]').val(0);
            $('input[name="page"]').val(1);
            $('input[name="searchKey"]').val(blogSearchText);
            IpixBlogs.loadMoreBlogs(false);
        });
    }

    return {
        init: function() {
            IpixBlogs.loadMoreBlogs(false, "");
            // loadBlogsOnScroll();
            loadMoreBtnClick();
            allClick();
            categoryClick();
            searchText();
        }
    }
}();

IpixBlogs.loadMoreBlogs = function(isMore) {
    var formData = $("#blogPaginationForm").serialize();
    $.ajax({
        url: $("#blogPaginationForm").attr("action"),
        type: 'GET',
        data: {
            formData: formData,
        },
        success: function(data) {
            if (isMore) {
                $("#blog-list-div").append(data.view);
                $("input[name='page']").val(parseInt(data.page) + parseInt(1));
            } else {
                $("#blog-list-div").html(data.view);
                $("input[name='page']").val(parseInt(data.page) + parseInt(1));
            }
            if (data.more == true) {
                $(".loadmore").show();
            } else {
                $(".loadmore").hide();
            }
        },
    });
}
